<template xmlns:v-field-control="http://www.w3.org/1999/xhtml">
    <div :class="{'p-animated-calc__column-one--section': showAddButton} ">
        <div :class="{'p-animated-calc__column-one--section-content': showAddButton} ">
            <control :name="'dependant_income'+index" :label="'Dependant '+(index+1)+' Net Income'" :no-flex-margin="true" before-after="pound">
                <input autocomplete="off" v-model.number="income"
                       :ref="reference"
                       name="dependant_income"
                       v-field-control:dependant_income.required="{type:'number'}"
                       id="dependantincome"
                       v-on:focus="income = income || ''"
                       v-on:blur="income = income || 0"
                       v-two-dp
                       min="0.00"
                       :disabled="disabled"
                       type="number"/>
                <control-error :show="$error('dependant_income')">
                    The Dependant's Net income is required and must be a valid amount
                </control-error>
            </control>
            <control :no-flex-margin="true">
            <div v-if="columnTwo">
                <div :class="{ 'a-form-inputs--half-calcs' : columnTwo }">
                    <div :class="{ 'a-form-inputs__container' : columnTwo }">
                        <button class="a-button a-button--grow u-r-margin-bottom-0" v-if="showAddButton" :class="{ 'p-dependency-calc__delete' : this.index < 1 }" @click="deleteDependant(index)">Delete</button>
                    </div>
                    <div :class="{ 'a-form-inputs__container' : columnTwo }">
                        <button class="a-button a-button--grow u-r-margin-top-0" v-if="showAddButton" @click="addDependent">Add</button>
                    </div>
                </div>
            </div>
            <div v-else>
                <button class="a-button" v-if="showAddButton" :class="{ 'p-dependency-calc__delete' : this.index < 1 }" @click="deleteDependant(index)">Delete</button>
                <button class="a-button" v-if="showAddButton" @click="addDependent">Add</button>
            </div>
            </control><br/>
        </div>
    </div>
</template>
<script>

    import {mapGetters, mapActions} from 'vuex';
    import ControlError from 'components/form/control/Error.vue';
    import CalculatorKeyBindings from 'pages/mini-calculators/calculators/mixins/MiniCalculatorBindings';
    import Control from 'components/form/Control.vue';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'DependantIncome',
        props: {
            index: {
                type: Number,
            },
            showAddButton: {
                type: Boolean,
                default: true,
            },
            reference: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            columnTwo: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Control,
            ControlError
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('mini/dependency', ['dependantIncome']),
            income: {
                get() {
                    return this.dependantIncome(this.index);
                },
                set(value) {
                    this.updateDependant({index: this.index, value});
                    this.calculateTotal();
                }
            },
        },
        methods: {
            ...mapActions('mini/dependency', ['updateDependant', 'calculateTotal']),
            addDependent() {
                this.$emit('addNewDependant');
                this.calculateTotal();
            },
            deleteDependant(index) {
                this.$emit('deleteDependant', index);
                this.calculateTotal();
            }
        },
        mixins: [
            FormValidator,
            CalculatorKeyBindings
        ],
    }
</script>



// WEBPACK FOOTER //
// DependantIncome.vue?66e3fbc8